import { createContext } from 'react';

import { ModalPopupContextValue } from './ModalProvider';

export const ModalPopupContext = createContext<ModalPopupContextValue | null>(null);
